import { render } from "./Container.vue?vue&type=template&id=676d3dd4&scoped=true&ts=true"
import script from "./Container.vue?vue&type=script&lang=ts"
export * from "./Container.vue?vue&type=script&lang=ts"

import "./Container.vue?vue&type=style&index=0&id=676d3dd4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676d3dd4"]])

export default __exports__